import { render, staticRenderFns } from "./TeamRanking.vue?vue&type=template&id=e1ec98a6&scoped=true"
import script from "./TeamRanking.vue?vue&type=script&lang=js"
export * from "./TeamRanking.vue?vue&type=script&lang=js"
import style0 from "./TeamRanking.vue?vue&type=style&index=0&id=e1ec98a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ec98a6",
  null
  
)

export default component.exports